import React, { createContext, useState, ReactNode, useContext, useEffect } from 'react';

interface ToasterContextProps {
  showToast: (message: string, type: 'success' | 'error' | 'deleted',data:string,duration?: number) => void;
}

const ToasterContext = createContext<ToasterContextProps | undefined>(undefined);

export const ToasterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [toast, setToast] = useState<{ message: string; type: 'success' | 'error' | 'deleted',data:string ,duration: number;} | null>(null);

  const showToast = (message: string, type: 'success' | 'error' | 'deleted',data:string, duration: number = 5000) => {
    setToast({ message, type,data,duration });
  };

  const hideToast = () => {
    setToast(null);
  };

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => {
        hideToast();
      }, toast.duration); // Duration for showing the toast

      return () => clearTimeout(timer);
    }
  }, [toast]);

  return (
    <ToasterContext.Provider value={{ showToast }}>
      {children}
      {toast && (
        <div className={`fixed top-[50px] right-4 max-w-xs w-full shadow-lg z-50 rounded-lg bg-white text-[#111827] p-5`}>
          <div className="flex justify-between items-start">
            <div className='flex text-[14px]'>
            <img src={getImageSrc(toast.type)} alt={toast.type} className="w-6 h-6 mr-2" />
            <div className='text-[#111827] font-medium'>{toast.message}
            <div className='text-[#6B7280] font-normal text-sm'>{toast.data}</div>
            </div>
            </div>
            <button onClick={hideToast}>
              <img src='/images/Dismiss_button.svg' alt='close' />
            </button>
          </div>
        </div>
      )}
    </ToasterContext.Provider>
  );
};

const getImageSrc = (type: 'success' | 'error' | 'deleted') => {
  switch (type) {
    case 'success':
      return '/images/successToaster.svg';
    case 'deleted':
      return '/images/Delete.svg';
    case 'error':
    default:
      return '/images/error.svg';
  }
};

const getBackgroundColor = (type: 'success' | 'error' | 'deleted') => {
  switch (type) {
    case 'success':
      return 'bg-[#ECFDF5]';
    case 'deleted':
      return 'bg-[#FDF4F5]';
    case 'error':
      return 'bg-[#FDF4F5]';
    default:
      return 'bg-white';
  }
};

// Custom hook to use the Toaster Context
export const useToaster = () => {
  const context = useContext(ToasterContext);
  if (context === undefined) {
    throw new Error('useToaster must be used within a ToasterProvider');
  }
  return context;
};
